const { getOptionValue } = require("common/enums");

export const getIsDocumentRequired = (
  documentRequiredEnum,
  isPartiallyUploading = false
) =>
  documentRequiredEnum ===
  getOptionValue(
    "documentRequiredEnum",
    isPartiallyUploading ? "partiallyRequired" : "required"
  );
